module.exports = __webpack_public_path__ + "static/media/5-_DSC7175.ecb8b734.jpg";